// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xhKzp_","tiny":"mlQktf","small":"XcEOgC","medium":"_9nnLPw","large":"IgSYF0","center":"Z9R6nO","rotation":"RXnPES","loading":"ztRBHx"};